module.exports = "<div class=\"scrollable more-wrapper\">\n  <div class=\"scrollable-content\">\n    <div class=\"more-header\">\n      <h3 class=\"home-heading\">{{strTitle}}</h3>\n    </div>\n\n    <div class=\"more-body\">\n      <iframe width=\"100%\" [src]=\"iframeLink\">\n        <p>Your browser does not support iframes.</p>\n      </iframe>  \n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/more/more.component.html
// module id = ../../../../../src/app/more/more.component.html
// module chunks = main